import { render } from "./AuthCallbackView.vue?vue&type=template&id=7eb8ac34&scoped=true"
import script from "./AuthCallbackView.vue?vue&type=script&lang=js"
export * from "./AuthCallbackView.vue?vue&type=script&lang=js"

import "./AuthCallbackView.vue?vue&type=style&index=0&id=7eb8ac34&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb8ac34"]])

export default __exports__